import React from 'react';
import { ResponsivePicture } from '@/components/ResponsivePicture';

// Above-the-fold hero image: a ResponsivePicture that loads first and is preloaded from <head>.
// fill defaults to true here (the hero covers its parent); pass fill={false} to let the image set the height.
export const HeroPicture = ({ fill = true, ...props }) => (
  <ResponsivePicture {...props} fill={fill} priority />
);
